import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, withKeys as _withKeys, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "tech-core-page"
};
const _hoisted_2 = {
  class: "tech-hero"
};
const _hoisted_3 = {
  class: "hero-content"
};
const _hoisted_4 = {
  class: "hero-wave-label"
};
const _hoisted_5 = {
  class: "t-section"
};
const _hoisted_6 = {
  class: "container"
};
const _hoisted_7 = {
  class: "night__track night__track--eeg"
};
const _hoisted_8 = {
  class: "night__state"
};
const _hoisted_9 = {
  class: "stations"
};
const _hoisted_10 = {
  class: "station__dot"
};
const _hoisted_11 = {
  class: "station__body"
};
const _hoisted_12 = {
  class: "station__label"
};
const _hoisted_13 = {
  class: "station__title"
};
const _hoisted_14 = {
  class: "station__text"
};
const _hoisted_15 = {
  class: "night__track night__track--audio"
};
const _hoisted_16 = {
  class: "night__state"
};
const _hoisted_17 = ["aria-valuenow"];
const _hoisted_18 = {
  class: "timeline__track",
  "aria-hidden": "true"
};
const _hoisted_19 = {
  class: "night__foot"
};
const _hoisted_20 = {
  class: "t-section t-section--gray"
};
const _hoisted_21 = {
  class: "container"
};
const _hoisted_22 = {
  class: "patent-wall"
};
const _hoisted_23 = {
  class: "patent-card__top"
};
const _hoisted_24 = {
  class: "patent-seal__text"
};
const _hoisted_25 = ["aria-label", "onClick"];
const _hoisted_26 = ["src", "onError"];
const _hoisted_27 = {
  class: "patent-card__type"
};
const _hoisted_28 = {
  class: "patent-card__title"
};
const _hoisted_29 = {
  class: "patent-card__meta"
};
const _hoisted_30 = {
  class: "patent-card__number"
};
const _hoisted_31 = {
  class: "patent-track"
};
const _hoisted_32 = {
  class: "patent-track__line",
  "aria-hidden": "true"
};
const _hoisted_33 = {
  class: "patent-track__label"
};
const _hoisted_34 = {
  class: "qualify"
};
const _hoisted_35 = {
  class: "qualify__list"
};
const _hoisted_36 = ["aria-label"];
const _hoisted_37 = {
  class: "cert-zoom__card"
};
const _hoisted_38 = ["src", "alt"];
const _hoisted_39 = {
  class: "t-section t-section--last"
};
const _hoisted_40 = {
  class: "container"
};
const _hoisted_41 = {
  class: "paper-grid"
};
const _hoisted_42 = {
  class: "paper-card__meta"
};
const _hoisted_43 = {
  class: "paper-card__journal"
};
const _hoisted_44 = {
  class: "paper-card__kind"
};
const _hoisted_45 = {
  class: "paper-card__title"
};
const _hoisted_46 = ["href"];
const _hoisted_47 = {
  class: "paper-card__foot"
};
const _hoisted_48 = ["href"];
const _hoisted_49 = ["onClick"];
const _hoisted_50 = {
  class: "paper-card__doi"
};
const _hoisted_51 = {
  key: 0,
  class: "paper-card__cite"
};
const _hoisted_52 = {
  class: "reading-grid"
};
const _hoisted_53 = ["href"];
const _hoisted_54 = {
  class: "reading-card__src"
};
const _hoisted_55 = {
  class: "reading-card__title"
};
import { computed, ref, watch, onMounted, onUnmounted } from 'vue';
import NavBar from '@/components/layout/NavBar.vue';
import Footer from '@/components/layout/Footer.vue';

// 专利：三项都做成证件卡；证书扫描件放在 public/patents/ 下，按 cert 字段命名即可自动出现
const NOISE_UPDATE_INTERVAL = 250;
const NIGHT_DURATION = 8200;
export default {
  __name: 'Tech',
  setup(__props) {
    const patents = [{
      id: 1,
      type: '发明专利',
      title: '基于 Micro:bit 微处理器的生理电信号测量分析方法及系统',
      numberLabel: '专利号',
      number: 'ZL 2019 1 1165953.2',
      date: '授权公告 2022-12-23',
      status: 'granted',
      statusText: '已授权',
      from: '2019',
      to: '2022',
      toLabel: '授权',
      cert: '/patents/patent-1.jpg'
    }, {
      id: 2,
      type: '发明专利',
      title: '用于单通道脑波测量设备的睡眠状态预测模型的建模方法',
      numberLabel: '申请号',
      number: '202311769847.1',
      date: '进入实审 2024-01-30',
      status: 'pending',
      statusText: '实审中',
      from: '2023',
      to: '2024',
      toLabel: '进入实审',
      cert: '/patents/patent-2.jpg'
    }, {
      id: 3,
      type: '发明专利',
      title: '一种基于 NeuroSky 脑波采集的睡眠状态建模及部署方法',
      numberLabel: '申请号',
      number: '202411796405.0',
      date: '进入实审 2025-03-28',
      status: 'pending',
      statusText: '实审中',
      from: '2024',
      to: '2025',
      toLabel: '进入实审',
      cert: '/patents/patent-3.jpg'
    }];

    // 资质与支持（沿用已有表述）
    const qualifications = ['中国残疾人辅助器具中心实验室检测', '入选无锡智慧健康医养设备促消费活动供应商品名录（脑机接口类）', '无锡市科技发展资金支持'];

    // 证书放大；扫描件还没放进来时自动隐藏缩略图
    const activeCert = ref(null);
    const missingCerts = ref([]);
    const openCert = patent => {
      activeCert.value = patent;
      document.documentElement.classList.add('cert-zoom-open');
    };
    const closeCert = () => {
      activeCert.value = null;
      document.documentElement.classList.remove('cert-zoom-open');
    };
    const onCertError = id => {
      if (!missingCerts.value.includes(id)) missingCerts.value = [...missingCerts.value, id];
      if (activeCert.value && activeCert.value.id === id) closeCert();
    };
    const onCertKeydown = event => {
      if (event.key === 'Escape') closeCert();
    };
    watch(activeCert, value => {
      if (value) window.addEventListener('keydown', onCertKeydown);else window.removeEventListener('keydown', onCertKeydown);
    });

    // 延伸阅读：同行评议研究（链接指向出版社正式页面，DOI 可核验）
    const papers = [{
      id: 1,
      journal: 'Journal of Neuroscience',
      year: '2011',
      kind: '实验研究',
      access: '免费全文',
      title: 'Tagging the neuronal entrainment to beat and meter',
      cite: 'Nozaradan S, Peretz I, Missal M, Mouraux A. Tagging the neuronal entrainment to beat and meter. J Neurosci. 2011;31(28):10234-10240.',
      doi: '10.1523/JNEUROSCI.0411-11.2011',
      url: 'https://doi.org/10.1523/JNEUROSCI.0411-11.2011'
    }, {
      id: 2,
      journal: 'Cochrane Database of Systematic Reviews',
      year: '2022',
      kind: '系统综述',
      access: '摘要免费',
      title: 'Listening to music for insomnia in adults',
      cite: 'Jespersen KV, Pando-Naude V, Koenig J, Jennum P, Vuust P. Listening to music for insomnia in adults. Cochrane Database Syst Rev. 2022;8(8):CD010459.',
      doi: '10.1002/14651858.CD010459.pub3',
      url: 'https://doi.org/10.1002/14651858.CD010459.pub3'
    }];

    // 中文解读（公众号转载，作为不想读英文的读者的入口）
    const readings = [{
      id: 1,
      source: '《SLEEP》期刊述评',
      title: '声音类睡眠辅助工具：用什么声音、以什么节奏播放，才更可能真正影响睡眠',
      url: 'https://mp.weixin.qq.com/s?__biz=MzU3NjY1Mzc0Mw==&mid=2247487526&idx=1&sn=6cb1513aa36acc705c27145487ac5ee8'
    }, {
      id: 2,
      source: '《Sleep》IF 7.0',
      title: '音乐改善主观睡眠，但 PSG 客观指标无显著变化',
      url: 'https://mp.weixin.qq.com/s?__biz=MzYzMTg4OTQ1MQ==&mid=2247486654&idx=1&sn=61c3d15043368db332af5b9fb443af4b'
    }, {
      id: 3,
      source: '《科学报告》',
      title: '音乐速度如何调控情绪与脑网络连接',
      url: 'https://mp.weixin.qq.com/s?__biz=MzAwNTAyMDY0MQ==&mid=2652742467&idx=2&sn=82425a0575ad35c470732bbc1921669d'
    }, {
      id: 4,
      source: '中科院心理研究所',
      title: '音乐镇痛的增效机制：基于感觉运动同步的神经电生理证据',
      url: 'https://mp.weixin.qq.com/s?__biz=MzIwNDQyNTI4NQ==&mid=2247484889&idx=1&sn=d1a3c605b0db42e9fb3d9e7107d6bebe'
    }, {
      id: 5,
      source: '上海交大精神卫生中心',
      title: '音乐干预改善慢性躯体疼痛与躯体化症状研究述评',
      url: 'https://mp.weixin.qq.com/s/1AoesVhVIySwn9JvdIKdEA'
    }, {
      id: 6,
      source: '声音与脑科学 · 科普',
      title: '焦虑睡不着？用声音「调」一下大脑频率',
      url: 'https://mp.weixin.qq.com/s?__biz=MzkxNjY0MDMyOQ==&mid=2247486098&idx=1&sn=03e6f5e12f724b74e32c50b901863670'
    }];

    // 复制引用：方便记者 / 投资方直接拿到规范引用
    const copiedId = ref(null);
    const copyFailed = ref(false);
    let copyTimer = null;

    // 优先用 Clipboard API；被浏览器拒绝（无权限 / 非 https）时退回 execCommand
    const copyText = async text => {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
          await navigator.clipboard.writeText(text);
          return true;
        } catch (error) {
          /* 继续走兜底方案 */
        }
      }
      try {
        const area = document.createElement('textarea');
        area.value = text;
        area.setAttribute('readonly', '');
        area.style.position = 'fixed';
        area.style.top = '-1000px';
        document.body.appendChild(area);
        area.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(area);
        return ok;
      } catch (error) {
        return false;
      }
    };
    const copyCitation = async paper => {
      const ok = await copyText(paper.cite + ' doi:' + paper.doi);
      copyFailed.value = !ok;
      copiedId.value = paper.id;
      if (copyTimer) window.clearTimeout(copyTimer);
      copyTimer = window.setTimeout(() => {
        copiedId.value = null;
        copyFailed.value = false;
        copyTimer = null;
      }, 1600);
    };

    // 当前波形阶段（驱动 hero 下方的标签高亮）
    const currentWave = ref('alpha');

    // 「它怎么工作」三段：脑电状态 → 判断 → 声音参数（三步文案沿用原来的）
    const steps = [{
      label: '采集',
      title: '干电极脑电信号',
      text: 'NeuroSky 单通道干电极芯片，512 Hz 采样，无需导电膏，贴合额头即可佩戴。',
      eeg: '清醒放松 · Alpha',
      audio: '12-30Hz',
      beat: '0.9s'
    }, {
      label: '理解',
      title: '睡眠分期模型',
      text: '低功耗蓝牙传输至手机，端侧模型实时区分清醒、浅睡、深睡，识别准确率高达 82.3%。',
      eeg: '入睡 · Theta',
      audio: '4-12Hz',
      beat: '1.35s'
    }, {
      label: '干预',
      title: '声音闭环反馈',
      text: '根据分期结果动态调整音频频率与节奏，由智能枕头播放，引导入睡而不是盖过你的脑波。',
      eeg: '深睡 · Delta',
      audio: '0.5-4Hz',
      beat: '1.9s'
    }];

    // 一夜的时间刻度（仅作示意的时间点）
    const ticks = ['22:30', '00:10', '01:40', '03:00'];

    // 回放进度：0 → 1 走完一夜
    const flowRef = ref(null);
    const scopeRef = ref(null);
    const canvasRef = ref(null);
    const armed = ref(false);
    const progress = ref(0);
    const playing = ref(false);
    const looping = ref(false);
    const scrubbing = ref(false);
    const manuallyStopped = ref(false);

    // 当前处于哪一拍
    const stageIndex = computed(() => {
      const index = Math.floor(progress.value * steps.length);
      return Math.min(steps.length - 1, Math.max(0, index));
    });

    // 拖动时间轴 / 键盘左右键回看
    const scrubTo = (clientX, el) => {
      const rect = el.getBoundingClientRect();
      progress.value = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
    };
    const startScrub = event => {
      const el = event.currentTarget;
      manuallyStopped.value = true;
      playing.value = false;
      looping.value = false;
      scrubbing.value = true;
      scrubTo(event.clientX, el);
      const onMove = e => scrubTo(e.clientX, el);
      const onUp = () => {
        scrubbing.value = false;
        window.removeEventListener('pointermove', onMove);
        window.removeEventListener('pointerup', onUp);
      };
      window.addEventListener('pointermove', onMove);
      window.addEventListener('pointerup', onUp);
    };
    const nudge = delta => {
      manuallyStopped.value = true;
      playing.value = false;
      looping.value = false;
      progress.value = Math.min(1, Math.max(0, progress.value + delta));
    };
    const replayNight = () => {
      manuallyStopped.value = false;
      looping.value = false;
      progress.value = 0;
      playing.value = true;
    };
    const prefersReducedMotion = () => typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // ===== Hero：三条波形交错在一起，并各自在 Alpha / Theta / Delta 之间渐变 =====
    const WAVE_ORDER = ['alpha', 'theta', 'delta'];

    // 波型 → 每屏宽度的头复周期数（Alpha 快而密，Delta 慢而大）
    const CYCLE_TABLE = {
      alpha: 10,
      theta: 6,
      delta: 3
    };
    let animationFrameId = null;
    function startHeroWave() {
      const canvas = document.getElementById('eegCanvas');
      if (!canvas) return () => {};
      const ctx = canvas.getContext('2d');
      const reduced = prefersReducedMotion();
      const noiseDots = [];

      // 每 250ms 重撒一批底噪点，位置随机；这批点在下一批到来前一直留在画面上
      function respawnNoise() {
        const w = canvas.offsetWidth;
        const h = canvas.offsetHeight;
        noiseDots.length = 0;
        for (let i = 0; i < 26; i++) {
          noiseDots.push({
            x: Math.random() * w,
            y: Math.random() * h,
            r: 0.7 + Math.random() * 1.6,
            a: 0.35 + Math.random() * 0.4
          });
        }
      }
      function resizeCanvas() {
        const dpr = window.devicePixelRatio || 1;
        canvas.width = Math.round(canvas.offsetWidth * dpr);
        canvas.height = Math.round(canvas.offsetHeight * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        respawnNoise();
      }
      resizeCanvas();
      window.addEventListener('resize', resizeCanvas);
      let time = 0;
      let cycle = 0;
      let cycleIndex = 0;
      let lastNoiseUpdate = -NOISE_UPDATE_INTERVAL;
      let nextSpawn = 0;
      let spawnCount = 0;

      // 三种波型 → 水波的疏密与丝带宽度：Alpha 密而细、Delta 疏而厚
      const RIPPLE = {
        alpha: {
          gap: 1.8,
          width: 7.5
        },
        theta: {
          gap: 2.8,
          width: 8.5
        },
        delta: {
          gap: 4.2,
          width: 9.5
        }
      };
      const COLORS = ['#ffcc00', '#4d7cff', '#3fc1c9'];
      const SPEED = 66; // 每单位时间向外扩散的像素
      const ripples = [];

      // 丝带：内层明亮高光 + 外层柔和宽带，两层叠出绸带质感
      const ribbon = (cx, cy, radius, width, color, alpha) => {
        ctx.beginPath();
        ctx.arc(cx, cy, radius, 0, Math.PI * 2);
        ctx.lineWidth = width;
        ctx.globalAlpha = alpha * 0.26;
        ctx.strokeStyle = color;
        ctx.shadowBlur = 0;
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(cx, cy, radius, 0, Math.PI * 2);
        ctx.lineWidth = width * 0.62;
        ctx.globalAlpha = alpha;
        ctx.strokeStyle = color;
        ctx.shadowColor = color;
        ctx.shadowBlur = 18;
        ctx.stroke();
        ctx.globalAlpha = 1;
        ctx.shadowBlur = 0;
      };
      function drawRipples(cx, cy, maxR) {
        if (reduced) {
          // 关闭动效：画几圈静态水波
          ;
          [0.62, 0.78, 0.94].forEach((k, i) => ribbon(cx, cy, maxR * k, 6.5, COLORS[i], 0.55));
          return;
        }

        // 波型在两型之间平滑过渡 → 水波间隔与丝带宽度跟着变
        const transition = cycle;
        const from = WAVE_ORDER[cycleIndex];
        const to = WAVE_ORDER[(cycleIndex + 1) % WAVE_ORDER.length];
        const gap = RIPPLE[from].gap * (1 - transition) + RIPPLE[to].gap * transition;
        const width = RIPPLE[from].width * (1 - transition) + RIPPLE[to].width * transition;
        // 手机上屏幕窄，让水波更早出现，否则还没看清就出画了
        const clearStart = Math.min(180, maxR * 0.22);
        if (time >= nextSpawn) {
          ripples.push({
            t0: time,
            color: COLORS[spawnCount % COLORS.length]
          });
          spawnCount += 1;
          nextSpawn = time + gap;
        }
        for (let i = ripples.length - 1; i >= 0; i--) {
          const ripple = ripples[i];
          const radius = (time - ripple.t0) * SPEED;
          if (radius > maxR) {
            ripples.splice(i, 1);
            continue;
          }
          const life = Math.min(1, radius / maxR);
          // 180px 以内不显示（避免压在标题上），之后淡入，向外扩散时慢慢淡出
          const clear = Math.min(1, Math.max(0, (radius - clearStart) / 150));
          const alpha = clear * Math.min(1, life / 0.1) * Math.pow(1 - life, 1.5);
          if (alpha <= 0.01) continue;
          ribbon(cx, cy, radius, width * (1 + life * 1.6), ripple.color, alpha * 0.95);
        }
      }
      function drawNoise(timestamp) {
        if (timestamp - lastNoiseUpdate > NOISE_UPDATE_INTERVAL) {
          lastNoiseUpdate = timestamp;
          respawnNoise();
        }
        ctx.fillStyle = '#ffd75e';
        noiseDots.forEach(dot => {
          ctx.globalAlpha = dot.a;
          ctx.shadowColor = 'rgba(255, 204, 0, 0.85)';
          ctx.shadowBlur = dot.r > 1.6 ? 7 : 0;
          ctx.beginPath();
          ctx.arc(dot.x, dot.y, dot.r, 0, Math.PI * 2);
          ctx.fill();
        });
        ctx.globalAlpha = 1;
        ctx.shadowBlur = 0;
      }
      function drawFrame(timestamp) {
        const w = canvas.offsetWidth;
        const h = canvas.offsetHeight;
        ctx.clearRect(0, 0, w, h);
        const maxR = Math.hypot(w, h) / 2 + 30;
        drawRipples(w / 2, h / 2, maxR);
        if (!reduced) drawNoise(timestamp);
        if (reduced) return;
        time += 0.05;
        cycle += 0.0045;
        if (cycle >= 1) {
          cycle -= 1;
          cycleIndex = (cycleIndex + 1) % WAVE_ORDER.length;
          currentWave.value = WAVE_ORDER[cycleIndex];
        }
        animationFrameId = requestAnimationFrame(drawFrame);
      }
      animationFrameId = requestAnimationFrame(drawFrame);
      return () => {
        window.removeEventListener('resize', resizeCanvas);
        if (animationFrameId) cancelAnimationFrame(animationFrameId);
        animationFrameId = null;
      };
    }

    // ===== 双轨时间轴：进视口自动播放一夜，也可以拖动时间轴回看 =====
    let stopNight = null;
    onMounted(() => {
      armed.value = true;
      const stopHero = startHeroWave();
      const flow = flowRef.value;
      const canvas = canvasRef.value;
      const scope = scopeRef.value;
      if (!flow || !canvas || !scope) {
        stopNight = stopHero;
        return;
      }
      const ctx = canvas.getContext('2d');
      const reduced = prefersReducedMotion();
      const smooth = t => t * t * (3 - 2 * t);
      const lerp = (a, b, t) => a + (b - a) * t;
      let running = false;
      let rafId = null;
      let last = 0;
      let phase = 0;
      let loopPauseUntil = 0;

      // 横向位置 → 该时刻的频率与幅度（清醒 → 浅睡 → 深睡）
      const waveParams = u => {
        const t = Math.min(1, Math.max(0, u));
        if (t < 0.5) {
          const s = smooth(t / 0.5);
          return {
            cycles: lerp(10, 6, s),
            amp: lerp(0.4, 0.58, s)
          };
        }
        const s = smooth((t - 0.5) / 0.5);
        return {
          cycles: lerp(6, 3, s),
          amp: lerp(0.58, 0.8, s)
        };
      };
      const drawScope = () => {
        const w = scope.clientWidth;
        const h = scope.clientHeight;
        if (!w || !h) return;
        const dpr = window.devicePixelRatio || 1;
        if (canvas.width !== Math.round(w * dpr) || canvas.height !== Math.round(h * dpr)) {
          canvas.width = Math.round(w * dpr);
          canvas.height = Math.round(h * dpr);
          ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        }
        ctx.clearRect(0, 0, w, h);
        const mid = h / 2;
        const half = h / 2 - 8;
        const since = progress.value * w;

        // 还没记录到的部分：淡基准线 + 两处分段刻度
        ctx.save();
        ctx.strokeStyle = 'rgba(15, 23, 42, 0.1)';
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(0, mid);
        ctx.lineTo(w, mid);
        ctx.stroke();
        ctx.setLineDash([3, 5]);
        ctx.strokeStyle = 'rgba(15, 23, 42, 0.12)';
        for (let s = 1; s <= 2; s++) {
          ctx.beginPath();
          ctx.moveTo(w * s / 3, mid - half);
          ctx.lineTo(w * s / 3, mid + half);
          ctx.stroke();
        }
        ctx.restore();
        if (since < 1) return;

        // 已经记录到的部分：越深睡越慢、越大
        ctx.save();
        ctx.lineWidth = 2.2;
        ctx.lineJoin = 'round';
        ctx.strokeStyle = '#ffcc00';
        ctx.shadowColor = 'rgba(255, 204, 0, 0.85)';
        ctx.shadowBlur = 10;
        ctx.beginPath();
        for (let x = 0; x <= since; x += 2) {
          const u = x / w;
          const p = waveParams(u);
          const y = mid + Math.sin(u * p.cycles * Math.PI * 2 + phase) * p.amp * half;
          x === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
        }
        ctx.stroke();
        ctx.restore();

        // 记录笔尖
        const pen = waveParams(since / w);
        const penY = mid + Math.sin(since / w * pen.cycles * Math.PI * 2 + phase) * pen.amp * half;
        ctx.save();
        ctx.fillStyle = '#ffcc00';
        ctx.shadowColor = 'rgba(255, 204, 0, 0.95)';
        ctx.shadowBlur = 16;
        ctx.beginPath();
        ctx.arc(since, penY, 3.4, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      };
      const frame = now => {
        if (!running) return;
        rafId = requestAnimationFrame(frame);
        const dt = last ? Math.min(64, now - last) : 16;
        last = now;
        if (!reduced) phase += dt * 0.004;
        if (playing.value) {
          progress.value = Math.min(1, progress.value + dt / NIGHT_DURATION);
          if (progress.value >= 1) {
            playing.value = false;
            looping.value = true;
            loopPauseUntil = now + 2000;
          }
        } else if (looping.value && now >= loopPauseUntil && !manuallyStopped.value) {
          looping.value = false;
          progress.value = 0;
          playing.value = true;
        }
        drawScope();
      };
      const startLoop = () => {
        if (running) return;
        running = true;
        last = 0;
        rafId = requestAnimationFrame(frame);
      };
      const stopLoop = () => {
        running = false;
        if (rafId) cancelAnimationFrame(rafId);
        rafId = null;
      };

      // 拖动或按键盘时也要重绘
      const stopWatch = watch(progress, () => {
        if (!running) drawScope();
      });
      if (reduced) {
        progress.value = 1;
        drawScope();
        stopNight = () => {
          stopHero();
          stopWatch();
        };
        return;
      }
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (!manuallyStopped.value) {
              if (progress.value >= 1 && !looping.value) progress.value = 0;
              playing.value = true;
            }
            startLoop();
          } else {
            playing.value = false;
            stopLoop();
          }
        });
      }, {
        threshold: 0.25
      });
      observer.observe(flow);
      stopNight = () => {
        stopHero();
        observer.disconnect();
        stopLoop();
        stopWatch();
      };
    });
    onUnmounted(() => {
      if (stopNight) stopNight();
      if (copyTimer) window.clearTimeout(copyTimer);
      window.removeEventListener('keydown', onCertKeydown);
      document.documentElement.classList.remove('cert-zoom-open');
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(NavBar), _createElementVNode("div", _hoisted_1, [_createElementVNode("section", _hoisted_2, [_cache[7] || (_cache[7] = _createElementVNode("div", {
        class: "eeg-canvas-container"
      }, [_createElementVNode("canvas", {
        id: "eegCanvas"
      })], -1)), _createElementVNode("div", _hoisted_3, [_cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "hero-badge"
      }, "TECHNOLOGY CORE", -1)), _cache[5] || (_cache[5] = _createElementVNode("h1", {
        class: "hero-title"
      }, "技术核心", -1)), _cache[6] || (_cache[6] = _createElementVNode("p", {
        class: "hero-subtitle"
      }, "基于脑电监测的新一代智能助眠系统", -1)), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", {
        class: _normalizeClass({
          active: currentWave.value === 'alpha'
        })
      }, "Alpha · 清醒放松", 2), _cache[2] || (_cache[2] = _createElementVNode("span", {
        class: "hero-wave-sep"
      }, "→", -1)), _createElementVNode("span", {
        class: _normalizeClass({
          active: currentWave.value === 'theta'
        })
      }, "Theta · 浅睡", 2), _cache[3] || (_cache[3] = _createElementVNode("span", {
        class: "hero-wave-sep"
      }, "→", -1)), _createElementVNode("span", {
        class: _normalizeClass({
          active: currentWave.value === 'delta'
        })
      }, "Delta · 深睡", 2)])])]), _createElementVNode("section", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_cache[13] || (_cache[13] = _createElementVNode("header", {
        class: "t-head"
      }, [_createElementVNode("h2", {
        class: "t-head__title"
      }, "工作原理"), _createElementVNode("span", {
        class: "t-head__rule"
      })], -1)), _cache[14] || (_cache[14] = _createElementVNode("p", {
        class: "t-lead"
      }, " 佩戴头带采集脑电 → 识别当前睡眠阶段 → 实时调整枕头播放的声音参数。不强行催眠，而是跟着你的入睡节奏走。 ", -1)), _createElementVNode("div", {
        ref_key: "flowRef",
        ref: flowRef,
        class: _normalizeClass(["night", {
          'is-armed': armed.value,
          'is-playing': playing.value,
          'is-looping': looping.value
        }])
      }, [_createElementVNode("div", _hoisted_7, [_cache[8] || (_cache[8] = _createElementVNode("span", {
        class: "night__tag"
      }, "脑电", -1)), _createElementVNode("span", _hoisted_8, _toDisplayString(steps[stageIndex.value].eeg), 1), _cache[9] || (_cache[9] = _createElementVNode("span", {
        class: "night__hint"
      }, "EEG · 512Hz 采样", -1))]), _createElementVNode("div", {
        ref_key: "scopeRef",
        ref: scopeRef,
        class: "night__scope"
      }, [_createElementVNode("canvas", {
        ref_key: "canvasRef",
        ref: canvasRef,
        class: "night__canvas",
        "aria-hidden": "true"
      }, null, 512)], 512), _createElementVNode("ol", _hoisted_9, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(steps, (step, index) => {
        return _createElementVNode("li", {
          key: step.label,
          class: _normalizeClass(["station", {
            'is-active': stageIndex.value === index,
            'is-done': stageIndex.value > index
          }])
        }, [_createElementVNode("span", _hoisted_10, [_createTextVNode(_toDisplayString(String(index + 1).padStart(2, '0')) + " ", 1), _cache[10] || (_cache[10] = _createElementVNode("span", {
          class: "station__pulse",
          "aria-hidden": "true"
        }, null, -1))]), _createElementVNode("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, _toDisplayString(step.label), 1), _createElementVNode("h3", _hoisted_13, _toDisplayString(step.title), 1), _createElementVNode("p", _hoisted_14, _toDisplayString(step.text), 1)])], 2);
      }), 64))]), _createElementVNode("div", _hoisted_15, [_cache[11] || (_cache[11] = _createElementVNode("span", {
        class: "night__tag"
      }, "声音", -1)), _createElementVNode("span", {
        class: "equalizer",
        style: _normalizeStyle({
          '--beat': steps[stageIndex.value].beat
        }),
        "aria-hidden": "true"
      }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(18, n => {
        return _createElementVNode("i", {
          key: n,
          style: _normalizeStyle({
            animationDelay: `${n % 6 * 0.11}s`,
            animationDuration: `calc(var(--beat) * ${1 + n % 3 * 0.12})`
          })
        }, null, 4);
      }), 64))], 4), _createElementVNode("span", _hoisted_16, _toDisplayString(steps[stageIndex.value].audio), 1)]), _createElementVNode("div", {
        class: "timeline",
        role: "slider",
        tabindex: "0",
        "aria-label": "拖动回看这一夜的过程",
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": Math.round(progress.value * 100),
        onPointerdown: startScrub,
        onKeydown: [_cache[0] || (_cache[0] = _withKeys(_withModifiers($event => nudge(-0.05), ["prevent"]), ["left"])), _cache[1] || (_cache[1] = _withKeys(_withModifiers($event => nudge(0.05), ["prevent"]), ["right"]))]
      }, [_createElementVNode("span", _hoisted_18, [_createElementVNode("span", {
        class: "timeline__fill",
        style: _normalizeStyle({
          transform: `scaleX(${progress.value})`
        })
      }, null, 4)]), _createElementVNode("span", {
        class: "timeline__cursor",
        style: _normalizeStyle({
          left: `${progress.value * 100}%`
        }),
        "aria-hidden": "true"
      }, null, 4), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ticks, (tick, index) => {
        return _createElementVNode("span", {
          key: tick,
          class: _normalizeClass(["timeline__tick", {
            'is-first': index === 0,
            'is-last': index === ticks.length - 1
          }]),
          style: _normalizeStyle({
            left: `${index / (ticks.length - 1) * 100}%`
          })
        }, _toDisplayString(tick), 7);
      }), 64))], 40, _hoisted_17), _createElementVNode("p", _hoisted_19, [_createElementVNode("span", {
        class: _normalizeClass(["night__foot-dot", {
          'is-on': looping.value || playing.value
        }]),
        "aria-hidden": "true"
      }, null, 2), manuallyStopped.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_cache[12] || (_cache[12] = _createTextVNode(" 已暂停自动播放 · ")), _createElementVNode("button", {
        type: "button",
        class: "night__replay",
        onClick: replayNight
      }, "重播一夜")], 64)) : looping.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createTextVNode("一夜结束，模型带着新的数据回到起点")], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [_createTextVNode("拖动时间轴可回看任意时刻")], 64))])], 2)])]), _createElementVNode("section", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_cache[20] || (_cache[20] = _createStaticVNode("<header class=\"t-head t-head--right\" data-v-54ad27f3><span class=\"t-head__rule\" data-v-54ad27f3></span><h2 class=\"t-head__title\" data-v-54ad27f3>专利与资质</h2></header><ul class=\"patent-stats\" data-v-54ad27f3><li data-v-54ad27f3><strong data-v-54ad27f3>3</strong><span data-v-54ad27f3>已申请发明专利</span></li><li data-v-54ad27f3><strong data-v-54ad27f3>1</strong><span data-v-54ad27f3>已授权</span></li><li data-v-54ad27f3><strong data-v-54ad27f3>2</strong><span data-v-54ad27f3>实质审查中</span></li></ul>", 2)), _createElementVNode("ul", _hoisted_22, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(patents, patent => {
        return _createElementVNode("li", {
          key: patent.id,
          class: "patent-card"
        }, [_createElementVNode("div", _hoisted_23, [_createElementVNode("span", {
          class: _normalizeClass(["patent-seal", `is-${patent.status}`])
        }, [_cache[15] || (_cache[15] = _createElementVNode("span", {
          class: "patent-seal__ring",
          "aria-hidden": "true"
        }, null, -1)), _createElementVNode("span", _hoisted_24, _toDisplayString(patent.statusText), 1)], 2), patent.cert && !missingCerts.value.includes(patent.id) ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "patent-card__cert",
          "aria-label": `放大查看证书：${patent.title}`,
          onClick: $event => openCert(patent)
        }, [_createElementVNode("img", {
          src: patent.cert,
          alt: "",
          onError: $event => onCertError(patent.id)
        }, null, 40, _hoisted_26), _cache[16] || (_cache[16] = _createElementVNode("span", null, "证书", -1))], 8, _hoisted_25)) : _createCommentVNode("", true)]), _createElementVNode("p", _hoisted_27, _toDisplayString(patent.type), 1), _createElementVNode("h3", _hoisted_28, _toDisplayString(patent.title), 1), _createElementVNode("dl", _hoisted_29, [_createElementVNode("div", null, [_createElementVNode("dt", null, _toDisplayString(patent.numberLabel), 1), _createElementVNode("dd", _hoisted_30, _toDisplayString(patent.number), 1)]), _createElementVNode("div", null, [_cache[17] || (_cache[17] = _createElementVNode("dt", null, "进度", -1)), _createElementVNode("dd", null, _toDisplayString(patent.date), 1)])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("span", null, _toDisplayString(patent.from), 1), _createElementVNode("span", _hoisted_32, [_cache[18] || (_cache[18] = _createElementVNode("i", {
          class: "patent-track__dot"
        }, null, -1)), _createElementVNode("i", {
          class: _normalizeClass(["patent-track__dot", {
            'is-open': patent.status !== 'granted'
          }])
        }, null, 2)]), _createElementVNode("span", null, _toDisplayString(patent.to), 1), _createElementVNode("span", _hoisted_33, _toDisplayString(patent.toLabel), 1)])]);
      }), 64))]), _createElementVNode("div", _hoisted_34, [_cache[19] || (_cache[19] = _createElementVNode("p", {
        class: "qualify__title"
      }, "资质与支持", -1)), _createElementVNode("ul", _hoisted_35, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(qualifications, item => {
        return _createElementVNode("li", {
          key: item
        }, _toDisplayString(item), 1);
      }), 64))])])])]), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [activeCert.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "cert-zoom",
        role: "dialog",
        "aria-modal": "true",
        "aria-label": `${activeCert.value.title} 证书`,
        onClick: _withModifiers(closeCert, ["self"])
      }, [_createElementVNode("figure", _hoisted_37, [_createElementVNode("img", {
        src: activeCert.value.cert,
        alt: `${activeCert.value.title} 证书`
      }, null, 8, _hoisted_38), _createElementVNode("figcaption", null, _toDisplayString(activeCert.value.type) + " · " + _toDisplayString(activeCert.value.number), 1), _createElementVNode("button", {
        type: "button",
        class: "cert-zoom__close",
        "aria-label": "关闭",
        onClick: closeCert
      }, "✕")])], 8, _hoisted_36)) : _createCommentVNode("", true)])), _createElementVNode("section", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_cache[24] || (_cache[24] = _createElementVNode("header", {
        class: "t-head"
      }, [_createElementVNode("h2", {
        class: "t-head__title"
      }, "延伸阅读"), _createElementVNode("span", {
        class: "t-head__rule"
      })], -1)), _cache[25] || (_cache[25] = _createElementVNode("p", {
        class: "ref-sub"
      }, "同行评议研究", -1)), _createElementVNode("ul", _hoisted_41, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(papers, paper => {
        return _createElementVNode("li", {
          key: paper.id,
          class: "paper-card"
        }, [_createElementVNode("div", _hoisted_42, [_createElementVNode("span", _hoisted_43, _toDisplayString(paper.journal), 1), _cache[21] || (_cache[21] = _createElementVNode("span", {
          "aria-hidden": "true"
        }, "·", -1)), _createElementVNode("span", null, _toDisplayString(paper.year), 1), _createElementVNode("span", _hoisted_44, _toDisplayString(paper.kind), 1)]), _createElementVNode("h3", _hoisted_45, [_createElementVNode("a", {
          href: paper.url,
          target: "_blank",
          rel: "noopener noreferrer"
        }, _toDisplayString(paper.title), 9, _hoisted_46)]), _createElementVNode("div", _hoisted_47, [_createElementVNode("a", {
          class: "paper-card__more",
          href: paper.url,
          target: "_blank",
          rel: "noopener noreferrer"
        }, [_createTextVNode(_toDisplayString(paper.access) + " · 阅读原文 ", 1), _cache[22] || (_cache[22] = _createElementVNode("span", {
          "aria-hidden": "true"
        }, "↗", -1))], 8, _hoisted_48), _createElementVNode("button", {
          type: "button",
          class: "paper-card__copy",
          onClick: $event => copyCitation(paper)
        }, _toDisplayString(copiedId.value === paper.id ? copyFailed.value ? '请手动复制' : '已复制' : '复制引用'), 9, _hoisted_49)]), _createElementVNode("p", _hoisted_50, "DOI " + _toDisplayString(paper.doi), 1), copiedId.value === paper.id && copyFailed.value ? (_openBlock(), _createElementBlock("p", _hoisted_51, _toDisplayString(paper.cite), 1)) : _createCommentVNode("", true)]);
      }), 64))]), _cache[26] || (_cache[26] = _createElementVNode("p", {
        class: "ref-sub"
      }, "中文解读（转载）", -1)), _createElementVNode("ul", _hoisted_52, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(readings, item => {
        return _createElementVNode("li", {
          key: item.id
        }, [_createElementVNode("a", {
          class: "reading-card",
          href: item.url,
          target: "_blank",
          rel: "noopener noreferrer"
        }, [_createElementVNode("span", _hoisted_54, _toDisplayString(item.source), 1), _createElementVNode("span", _hoisted_55, _toDisplayString(item.title), 1), _cache[23] || (_cache[23] = _createElementVNode("span", {
          class: "reading-card__go",
          "aria-hidden": "true"
        }, "↗", -1))], 8, _hoisted_53)]);
      }), 64))])])])]), _createVNode(Footer)], 64);
    };
  }
};